import profileconfigGeneral from '@/store/modules/profileconfig/general';

export default {
  profileconfigGeneral,
};
